import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'

const PageHeader = ({ templateId }) => {
  const navigate = usePermalinkNavigation()

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/list`)}
      title={'Avaliação Ergonômica do Trabalho'}
      mediumPadding
      noContainer
      side={
        <TemplateRecordPdfPrintButton name={'Avaliação Ergonômica do Trabalho'} recordId={11} templateId={templateId} />
      }
    />
  )
}

export default PageHeader
